import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import AssetRoutes from '../../Component/Layouts/AddAssets';


const mdTheme = createTheme();

function Custodians() {
 
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <div className='sidebarsetting' >
        <Appbar mainpage="Home" subpage="Add Assets"/>
          </div>
        <AssetRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function AddAssets() {
  return <Custodians />
}